import './styles.css';
import {useState, useEffect} from 'react';
import { flashCardData } from './flashCardData';
import { shuffleDataArray } from '../../hooks/dataHooks';
import FlashCardsBeginModal from '../../common/FlashCardsBeginModal';
import FlashCardsSession from '../../common/FlashCardsSession';
import SEO from '../../common/SEO';
import { Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import PageNotFound from '../../common/PageNotFound';


const violinOptions = [
	{
		stackName: 'Notes on G string',
		stackDescription: 'Notes for G string - first position (G, A, B, C, D)',
		stackPhoto: "/assets/images/flashCards/G_string_stack.png",
		stackId: 'g_string'
	},
	{
		stackName: 'Notes on D string',
		stackDescription: 'Notes for D string - first position (D, E, F, G, A)',
		stackPhoto: "/assets/images/flashCards/D_string_stack.png",
		stackId: 'd_string'
	},
	{
		stackName: 'Notes on A string',
		stackDescription: 'Notes for A string - first position (A, B, C, D, E)',
		stackPhoto: "/assets/images/flashCards/A_string_stack.png",
		stackId: 'a_string'
	},
	{
		stackName: 'Notes on E string',
		stackDescription: 'Notes for E string - first position (E, F, G, A, B)',
		stackPhoto: "/assets/images/flashCards/E_string_stack.png",
		stackId: 'e_string'
	},
	{
		stackName: 'Beyond 1st postion',
		stackDescription: 'High E string notes - 3rd to 5th positions (A, B, C, D, E, F)',
		stackPhoto: "/assets/images/flashCards/high_notes_stack.png",
		stackId: 'e_string_high'
	}
];


const pianoOptions = [
	{
		stackName: 'Treble: Lower notes',
		stackDescription: '5 treble clef notes - lower range',
		stackPhoto: "/assets/images/flashCards/treble_lower_stack.png",
		stackId: 'treble_lower'
	},
	{
		stackName: 'Treble: Center notes',
		stackDescription: '6 treble clef notes - center of piano',
		stackPhoto: "/assets/images/flashCards/treble_center_stack.png",
		stackId: 'treble_center'
	},
	{
		stackName: 'Treble: Higher notes',
		stackDescription: '6 treble clef notes - higher range',
		stackPhoto: "/assets/images/flashCards/treble_higher_stack.png",
		stackId: 'treble_higher'
	},
	{
		stackName: 'Treble: Very high',
		stackDescription: '6 treble clef notes - very high range',
		stackPhoto: "/assets/images/flashCards/high_notes_stack.png",
		stackId: 'treble_very_high'
	},
	{
		stackName: 'Bass: Very low',
		stackDescription: '6 bass clef notes - very low range',
		stackPhoto: "/assets/images/flashCards/bass_very_low_stack.png",
		stackId: 'bass_very_low'
	},
	{
		stackName: 'Bass: Lower notes',
		stackDescription: '6 bass clef notes - lower range',
		stackPhoto: "/assets/images/flashCards/bass_lower_stack.png",
		stackId: 'bass_lower'
	},
	{
		stackName: 'Bass: Higher notes',
		stackDescription: '5 bass clef notes - higher range',
		stackPhoto: "/assets/images/flashCards/bass_higher_stack.png",
		stackId: 'bass_higher'
	},
	
];

const FlashCardPage = () => {
	const [chosenFlashCardsData, setChosenFlashCardsData] = useState([]);
	const [chosenFlashCardsInitNum, setChosenFlashCardsInitNum] = useState(0);
	const [isBeginModalOpen, setIsBeginModalOpen] = useState(true);
	const [isEndModalOpen, setIsEndModalOpen] = useState(false);
	const [stackOptions, setStackOptions] = useState([])
	const location = useLocation();
	const param = location.pathname.replace('/flashcards/', '')
	const paramExist = param === 'for_violin' || param === 'for_piano'

	useEffect (() => {
		location.pathname === '/flashcards/for_piano' ? setStackOptions(pianoOptions) : setStackOptions(violinOptions) 
		setChosenFlashCardsData([]);
		setIsBeginModalOpen(true);
	}, [location.pathname])

	const convertChosenStackToData = (chosenStackArr) => {
		//1) map to find the correct data and push into an array
		let singleDataArr = [];
		chosenStackArr.map(choice => singleDataArr.push(flashCardData[choice]))

		//2) filter out the duplicates
		const key = 'noteImg';
		const filteredSingleData = [...new Map(singleDataArr.flat().map(note => [note[key], note])).values()];	

		//3) double the data
		let doubledData = filteredSingleData;
		filteredSingleData.map(item => doubledData.push(item))

		//4) shuffle data
		const shuffledDoubleData = shuffleDataArray(doubledData);

		//5) assign to flashCardData and initial numb
		setChosenFlashCardsData(shuffledDoubleData);
		setChosenFlashCardsInitNum(shuffledDoubleData.length)
	};

	const aboardSession = () => {
		setChosenFlashCardsData([]);
		setIsBeginModalOpen(true);
		setIsEndModalOpen(false);
	}

	return (
		<>
			<SEO pageName="flashcards"/>
			{ !paramExist ?
				<PageNotFound />
				:
				<>
					<Typography variant='h5' className='flashCardPageText'>Flashcards</Typography>
					{!!chosenFlashCardsData.length && !isBeginModalOpen &&
						<FlashCardsSession 
							chosenFlashCardsData={chosenFlashCardsData} 
							setChosenFlashCardsData={setChosenFlashCardsData}
							chosenFlashCardsInitNum={chosenFlashCardsInitNum}
							setIsEndModalOpen={setIsEndModalOpen}
							isEndModalOpen={isEndModalOpen}
							aboardSession={aboardSession}
							pathname={location.pathname}
						/>
					
					}
					<FlashCardsBeginModal 
						isBeginModalOpen={isBeginModalOpen} 
						setIsBeginModalOpen={setIsBeginModalOpen}
						convertChosenStackToData={convertChosenStackToData}
						chosenFlashCardsData={chosenFlashCardsData}
						setChosenFlashCardsData={setChosenFlashCardsData}
						stackOptions={stackOptions}
						pathname={location.pathname}
					/>
				</>
			}
		</>
	)
}

export default FlashCardPage;